import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import css from './ProgramDetails.module.css';

import toShort from '../../../../../services/utils/dateParser';
import { durationToMinutes, minutesToDuration, secondsToDuration } from '../../../../../services/utils/tna.js';
import * as programServices from '../../../../../services/programServices';
import * as tnaServices from '../../../../../services/tnaServices';
import ModalForm from '../../../_common/ModalForm';
import ExportProgramToDoc from './ExportProgramToDoc.jsx';
import AddNewProgram from '../overview/AddNewProgram.jsx';
// import AddNewCourse from '../overview/AddNewCourse';

function ProgramDetails() {
    const { programId } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [programDetails, setProgramDetails] = useState([{ programId }]);
    const [tnaDetails, setTnaDetails] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [allAtas, setAllAtas] = useState([]);
    const [processedTnaDetails, setProcessedTnaDetails] = useState([]);

    // console.log(programDetails[0]);
    // console.log(processedTnaDetails);

    //Open and close the input form
    const toggleModal = () => {
        setShowModal(!showModal);
    };

    const processTnaData = () => {
        if (!tnaDetails.tnaData || allAtas.length === 0) return;
        const processedData = allAtas?.map((ata) => {
            const ataModuleElement = tnaDetails.tnaData.modules?.map((module) => {
                const element = module.ata.find((item) => item.ataId === ata.ataId);
                return element;
            });

            const ataMcqElement = tnaDetails.tnaData.mcq.find((item) => item.ataId === ata.ataId);

            const totalAtaDuration = ataModuleElement.reduce((sum, item) => {
                return sum + durationToMinutes(item?.duration || '00:00:00');
            }, 0);

            const ataLevel = Math.max(...ataModuleElement?.map((lvl) => (lvl ? lvl.level : 0)));

            const ataMethods = ataModuleElement
                .map((item) => (item ? item.methods : ''))
                .join(',')
                .split(',')
                .map((x) => x.trim())
                .filter((value, index, self) => value && self.indexOf(value) === index);

            // console.log(ataMethods);

            return {
                ataId: ata.ataId,
                ataNo: ata.ataNo,
                ataTitle: ata.ataTitle,
                totalAtaDuration: minutesToDuration(totalAtaDuration),
                ataLevel,
                mcqQty: ataMcqElement ? ataMcqElement.mcqQty : 0,
                ataMethods,
            };
        });
        setProcessedTnaDetails(processedData.sort((a, b) => a.ataNo.localeCompare(b.ataNo)));
        // console.log(processedData);
    };

    useEffect(() => {
        if (!programId || showModal) return;
        setIsLoading(true);
        programServices
            .getById(programId)
            .then((result) => {
                // console.log(result.data);
                setProgramDetails((state) => result.data);
                if (result.data) {
                    const tnaId = result.data[0].tnaId;
                    tnaServices
                        .getLockedTnaById(tnaId)
                        .then((res) => {
                            // console.log(res.data);
                            setTnaDetails((state) => res.data[0]);
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false);
            });
    }, [programId, showModal]);

    useEffect(() => {
        if (!programId) return;
        tnaServices
            .getOption('getAllAtas')
            .then((res) => {
                setAllAtas(res.data || []);
            })
            .catch((err) => {
                console.error('Error fetching ATAs:', err);
            });
    }, []);

    useEffect(() => {
        if (!programId) return;
        if (tnaDetails?.tnaData && allAtas.length > 0) {
            processTnaData();
        }
    }, [tnaDetails, allAtas]);

    // console.log(tnaDetails.tnaData);
    // console.log(tnaDetails.tnaData);

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            <h1 className={css.h1}>{programDetails[0].programTitle}</h1>
            <h3 className={css.h3}>No: {programDetails[0].programNo}</h3>
            <div className={css.general}>
                <h2 className={css.h2}>General</h2>
                <div className={css.details}>
                    <div
                        // className={css.image}
                        // style={{
                        //     backgroundImage: `url(https://ih1.redbubble.net/image.3681930180.9834/mo,large,flatlay,product_square,600x600.jpg`,
                        // }}
                    ></div>
                    <div>
                        <p> A/C Type: <strong>{programDetails[0].aircraftTypeTitle}</strong> </p>
                        <p> Airframe: <strong>{programDetails[0].aircraftTypeAirframe}</strong> </p>
                        <p> Powerplant: <strong>{programDetails[0].aircraftTypePowerplant}</strong> </p>
                        <p> Course Type: <strong>{programDetails[0].courseTypeAbbreviation}</strong> </p>
                        <p> Cat: <strong>{programDetails[0].licenseCategoryTitle}</strong> </p>
                        <p> Rev: <strong>{programDetails[0].programRevisionNo}</strong> </p>
                        <p> Date: <strong>{programDetails[0].programRevisionDate}</strong> </p>
                        <button className={css.editButon} onClick={() => toggleModal()}>
                            Edit
                        </button>
                    </div>
                    <div>
                        {tnaDetails ? (
                            <>
                                <p> Total duration: <strong>{minutesToDuration(tnaDetails?.tnaTotalDurationMin)}</strong> </p>
                                <p> Total MCQ: <strong>{tnaDetails?.tnaTotalMcq}</strong> </p>
                            </>
                        ) : (
                            <p style={{color: 'red'}}>No TNA assigned</p>
                        )}
                        <p> EASA Rev: <strong>{programDetails[0].easaMtoeRev}</strong> </p>
                        <p> UK Rev: <strong>{programDetails[0].ukMtoeRev}</strong> </p>
                        <p> Created: <strong>{toShort(programDetails[0].createdOn)}</strong> </p>
                        <p> Modified: <strong>{toShort(programDetails[0].modifiedOn)}</strong> </p>
                        <p> Notes: {programDetails[0].programNotes}</p>
                    </div>
                </div>
            </div>
            <div className={css.course}>
                <h2 className={css.h2}>Details</h2>
                {tnaDetails && (<ExportProgramToDoc data={programDetails[0]} atas={processedTnaDetails} tnaDetails={tnaDetails} />)}
                <table className={css.table}>
                    <thead className={css.thead}>
                        <tr>
                            <th className={css.th}>ATA</th>
                            <th className={css.th}>Level</th>
                            <th className={css.th}>Duration</th>
                            <th className={css.th}>MCQ</th>
                            <th className={css.th}>Methods</th>
                        </tr>
                    </thead>
                    <tbody className={css.tbody}>
                        {processedTnaDetails?.map((ata) =>
                            ata.totalAtaDuration !== '00:00' ? (
                                <tr key={ata.ataId}>
                                    <td className={css.td}>
                                        ({ata.ataNo}) {ata.ataTitle}
                                    </td>
                                    <td className={css.td}>{ata.ataLevel}</td>
                                    <td className={css.td}>{ata.totalAtaDuration}</td>
                                    <td className={css.td}>{ata.mcqQty}</td>
                                    <td className={css.td}>{ata.ataMethods.join(', ')}</td>
                                </tr>
                            ) : null
                        )}
                    </tbody>
                </table>
            </div>

            <ModalForm showModal={showModal} toggleModal={toggleModal}>
                <AddNewProgram data={programDetails[0]} onAdd={() => {}} toggleModal={toggleModal} func={'edit'} />
            </ModalForm>
        </div>
    );
}

export default ProgramDetails;
